import axiosInstance from "../utils/axiosInstance";

export const getFaqs = async (debouncedSearch) => {
  return axiosInstance(`/faqs?searchTerm=${debouncedSearch}`, "GET", null).then(
    (response) => {
      return response;
    }
  );
};
